import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const TopNavStyleParts = ['banner', 'rightButtons', 'logo'] as const

const helpers = createMultiStyleConfigHelpers(TopNavStyleParts)

export const TopNavStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    banner: {
      backgroundColor: 'bg.panel',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 16px',
      display: 'flex',
      borderBottom: '2px solid',
      borderBottomColor: 'border.default',
    },
    rightButtons: {
      display: 'flex',
      gap: '12px',
      position: 'relative',
    },
    logo: {
      width: '100px',
      height: '25px',
      marginTop: '8px',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  },
})

export const useTopNavStyle = (
  props?: StyleThemingProps & { logo?: string },
) => {
  const baseStyles = mergeMultiStyleConfig(
    TopNavStyle,
    props,
  ) as MultiStyleType<typeof TopNavStyleParts>

  // Apply dynamic logo if provided
  if (props?.logo) {
    return {
      ...baseStyles,
      logo: {
        ...baseStyles.logo,
        backgroundImage: `url(${props.logo})`,
      },
    }
  }

  return baseStyles
}
